import { useEffect } from "react";
import { useMediaDeviceSelect } from "@livekit/components-react";
import { MicrophoneDiagnostics } from "../audio-diagnostics/microphone-diagnostics";
import { SpeakerDiagnostics } from "../audio-diagnostics/speaker-diagnostics";
import s from "../conference-settings-modal.module.scss";

export const DeviceSelect = ({
  label,
  kind,
  value,
  onPersist,
  sectionClassName = "",
  volume,
  track,
}) => {
  const { devices, activeDeviceId, setActiveMediaDevice } = useMediaDeviceSelect({
    kind,
    track,
    requestPermissions: true,
  });
  const selectedDeviceId = activeDeviceId || value || "";

  useEffect(() => {
    if (!value || !devices.some((device) => device.deviceId === value) || activeDeviceId === value) {
      return;
    }

    void setActiveMediaDevice(value, { exact: value !== "default" });
  }, [activeDeviceId, devices, setActiveMediaDevice, value]);

  return (
    <div className={`${s.settingRow} ${sectionClassName}`.trim()}>
      <div className={s.settingMeta}>
        <div className={s.settingLabel}>{label}</div>
        <div className={s.settingCaption}>
          {devices.length ? `${devices.length} устройств` : "Устройства не найдены"}
        </div>
      </div>
      <select
        className={s.select}
        value={selectedDeviceId}
        onChange={(event) => {
          const nextValue = event.target.value;
          setActiveMediaDevice(nextValue, { exact: nextValue !== "default" });
          onPersist?.(nextValue);
        }}
      >
        {!devices.length ? <option value="">Нет доступных устройств</option> : null}
        {devices.map((device, index) => (
          // deviceId бывает пустым (нет разрешения / виртуальные устройства Windows) —
          // иначе получаем дублирующийся key "" и ворнинг React
          <option key={device.deviceId || `${kind}-device-${index}`} value={device.deviceId}>
            {device.label || `${label} ${device.deviceId.slice(0, 8)}`}
          </option>
        ))}
      </select>
      {kind === "audioinput" ? (
        <MicrophoneDiagnostics
          deviceId={selectedDeviceId}
        />
      ) : null}
      {kind === "audiooutput" ? <SpeakerDiagnostics deviceId={selectedDeviceId} volume={volume} /> : null}
    </div>
  );
};
